module.exports = __webpack_public_path__ + "img/ficha_BanBajio.d7412a9e.jpg";